import { render, staticRenderFns } from "./SigningHistory.vue?vue&type=template&id=8b25a746"
import script from "./SigningHistory.vue?vue&type=script&lang=js"
export * from "./SigningHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports